import { memo } from "react";
import PlayerPlayIcon from "./images/icons/player-play.svg?react";
import "./PlayButton.scss";

interface IPlayButton {
  onContextMenu?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const PlayButton = memo(({ onContextMenu }: IPlayButton) => {
  return (
    <button
      className="playButton"
      onContextMenu={onContextMenu}
    >
      <PlayerPlayIcon />
    </button>
  );
});
